import icons from '../../img/icons.svg';
import View from './View.js';
import previewView from './previewView';

class ResultsView extends View {
  _parentElement = document.querySelector('.results');
  _errorMsg = 'No results found!';
  _msg = '';

  _generateMarkup() {
    return this._data.map((result) => previewView.render(result, false)).join('');
  }
}

export default new ResultsView();
